import React, { useContext } from 'react';
import styled from 'styled-components';

import PromotionModalContext from '../../../modules/contexts/PromotionModalContext';

import { babyface } from '../../../lib/image/CDNUrl';
import { Flex } from '../atom/Layout';
import { Button } from '../atom/Button';
import { breakpoint } from '../../../lib/style/ThemeStyle';
import * as PATH from '../../../lib/routes/path';
import { Link } from 'react-router-dom';

const promotionImg = babyface.concat('/service/babyface/event_miraeasset.jpg');
const promotionLink = `${PATH.EVENT_DETAIL}/miraeasset`

const PromotionModal = () => {
  const {
    state: { showModal },
    actions: { dayCloseModal, closeModal },
  } = useContext(PromotionModalContext);

  return (
    showModal && (
      <ModalBackground>
        <Flex column alignItems="stretch">
          <Link to={promotionLink} onClick={closeModal}>
            <ModalImg src={promotionImg} alt="❌" />
          </Link>
          <Flex alignItems="flex-start" justifyContent="flex-start">
            <ModalButton backgroundColor="#f5dee1" onClick={dayCloseModal}>
              오늘 하루 보지 않기
            </ModalButton>
            <ModalButton backgroundColor="#ecc2d1" onClick={closeModal}>
              닫기
            </ModalButton>
          </Flex>
        </Flex>
      </ModalBackground>
    )
  );
};

export default React.memo(PromotionModal);

const ModalImg = styled.img`
  display: block;
  width: 400px;
  object-fit: cover;
  @media (max-width: ${breakpoint}px) {
    width: 100%;
    max-width: 320px;
    height: 100%;
    object-fit: contain;
  }
`;

const ModalButton = styled(Button)`
  height: 2.5rem;
  font-size: 0.875rem;
  color: ${(props) => props.theme.color.darkest};
  border-radius: 0;
  background: ${(props) => props.backgroundColor};
  font-weight: 400;
`;

const ModalBackground = styled(Flex)`
  position: fixed;
  z-index: 102;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.32);
`;
